import React, { useEffect, useState } from 'react'
import { IPlanMenuControlOrdersRequest } from '../../../core/api/dto/PlanMenuControlDto'
import { useGetPlanMenuCloseOrdersQuery } from '../../../core/api/PlanMenuCloseApi'
import { IPlanMenuCloseOrderDto } from '../../../core/api/dto/PlanMenuCloseDto'
import { PlanMenuListBlock } from '../../PlanMenuControl/components/PlanMenuListBlock'

export interface IPlanMenuListProps {
  pageParams: IPlanMenuControlOrdersRequest | null
  setEditMode?: (value: boolean) => void
  reloadTrigger?: boolean
  setReloadTrigger: (value: boolean) => void
}

export const PlanMenuCloseList = ({
  pageParams,
  setEditMode,
  reloadTrigger,
  setReloadTrigger,
}: IPlanMenuListProps) => {
  const [offset, setOffset] = useState<number>(0)
  const [loadMore, setLoadMore] = useState<boolean>(false)
  const { data: ordersListData } = useGetPlanMenuCloseOrdersQuery(
    {
      ...pageParams,
      offset,
    },
    { skip: !pageParams },
  )
  const [ordersList, setOrdersList] = useState<IPlanMenuCloseOrderDto[]>([])

  useEffect(() => {
    if (offset === 0 && !!ordersListData) {
      setOrdersList(ordersListData.results)
    }
    if (offset !== 0 && !!ordersListData && loadMore) {
      setOrdersList((prevState) => [...prevState, ...ordersListData.results])
      setLoadMore(false)
    }
  }, [ordersListData])
  // Обновляем список при изменении reloadTrigger
  useEffect(() => {
    if (reloadTrigger) {
      setOffset(0) // Сброс страниц при обновлении данных
    }
    console.log('reloadTrigger1', reloadTrigger)
    setReloadTrigger(false)
  }, [reloadTrigger]) // Обновляем данные при изменении триггера

  const nextPageHandler = () => {
    setLoadMore(true)
    setOffset((prevState) => prevState + 40)
  }

  return (
    <PlanMenuListBlock
      ordersList={ordersList}
      next={ordersListData?.next}
      nextPageHandler={nextPageHandler}
      setEditMode={setEditMode}
    />
  )
}
